import { render, staticRenderFns } from "./StartUp.vue?vue&type=template&id=e0bb82b6&scoped=true&"
import script from "./StartUp.vue?vue&type=script&lang=js&"
export * from "./StartUp.vue?vue&type=script&lang=js&"
import style0 from "./StartUp.vue?vue&type=style&index=0&id=e0bb82b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bb82b6",
  null
  
)

export default component.exports